
let termsModalRendered = false

class GTCTerms extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {

        this.settings = {
            ...JSON.parse(this.getAttribute('settings'))
        };
 
        this.dom = {
            main: this,
            checkBox: this.querySelector('#GtcTermsCheck')
        }

        this.cartParent = this.dom.main.closest(this.settings.parentSelector);

        this.cartForm = this.cartParent.querySelector('form[action="/cart"]');

        this.cartSubmit = this.cartParent.querySelector(this.settings.submitSelector);

        this.cartSubmitDefaultClasses = this.cartSubmit.classList.value;

        this.Init();
    }

    disconnectedCallback() {
        this.RemoveListeners();
    }

    Init() {
        this.Binding();
        this.AddListeners();
    }

    Binding() {
        this.Click = this.Click.bind(this)
    }

    AddListeners() {
        this.addEventListener('click', this.Click);
        this.cartForm.addEventListener('submit', (e) => {
            this.Validate(e);
        })

        document.addEventListener('terms:accepted', () => {
            this.AcceptAndSubmit();
        })
    }

    RemoveListeners() {
        this.removeEventListener('click', this.Click);
        this.cartForm.removeEventListener('submit', (e) => {
            this.Validate(e);
        })

        document.removeEventListener('terms:accepted', () => {
            this.AcceptAndSubmit();
        })
    }

    AcceptAndSubmit() {
        this.dom.checkBox.checked = true;
        this.cartSubmit.click();
    }

    Validate(e) {
        if (!this.dom.checkBox.checked) {
            e.preventDefault();
            setTimeout(() => {
                this.cartSubmit.classList.value = this.cartSubmitDefaultClasses;
            }, 0);

            if (termsModalRendered) {
                this.ModalOpen({ expandOnLoad: false });
            }
            else {
                this.CreateModal({ expandOnLoad: false });
            }
        }
    }

    CreateModal({ expandOnLoad }) {
        const termsModalTemplate = this.cartParent.querySelector('#TermsModal');
        this.termsModal = termsModalTemplate.content.cloneNode(true);
        this.cartParent.appendChild(this.termsModal);

        this.ModalOpen({ expandOnLoad });
        termsModalRendered = true;
    }

    ModalOpen({ expandOnLoad }) {
        document.dispatchEvent(new CustomEvent('terms:modal:open', {
            detail: {
                expandOnLoad: expandOnLoad
            }
        }))
    }

    Click(event) {
        if (event.target.getAttribute('href') == this.settings.url) {
            event.preventDefault();
            setTimeout(() => {
                if (termsModalRendered) {
                    this.ModalOpen({ expandOnLoad: true });
                }
                else {
                    this.CreateModal({ expandOnLoad: true });
                }
            }, 0);
        }
    }
}
customElements.define('gtc-terms', GTCTerms)

class GTCTermsModal extends HTMLElement {
    static get observedAttributes() { return ['open', 'expanded']; }
    constructor() {
        super();
    }

    connectedCallback() {

        this.settings = {
            ...JSON.parse(this.getAttribute('settings')),
            expandedTextLoaded: false
        };

        this.dom = {
            main: this,
            expandedContent: this.querySelector('[data-expanded-content]'),
            termsSection: this.querySelector('[data-terms-content-terms]'),
        }

        // Forces repaint, so it animates nicely
        void this.offsetHeight;

        this.Binding();
        this.AddListeners();

        // This eventlistener should not be removed
        document.addEventListener('terms:modal:open', this.Open);
    }

    disconnectedCallback() {
        this.RemoveListeners();
        termsModalRendered = false;
    }

    Binding() {
        this.Keydown = this.Keydown.bind(this);
        this.Open = this.Open.bind(this)
        this.Click = this.Click.bind(this)
    }

    AddListeners() {
        document.addEventListener('click', this.Click);
        document.addEventListener("keydown", this.Keydown);
    }

    RemoveListeners() {
        document.removeEventListener('click', this.Click);
        document.removeEventListener("keydown", this.Keydown);
    }

    Click(event) {
        if (event.target.getAttribute('terms') == 'accept') {
            document.dispatchEvent(new CustomEvent('terms:accepted'));
            this.Close();
        } else if (event.target.getAttribute('terms') == 'decline' || !this.dom.main.contains(event.target)) {
            this.Close();
        } else if (event.target.getAttribute('data-button') === "close") {
            this.Close();
        } else if (event.target.getAttribute('href') == this.settings.url) {
            this.ExpandText(event);
        } else if (event.target.getAttribute('data-button') === "expanded-close") {
            this.CloseText();
        }
    }

    OpenText() {
        this.setAttribute('expanded', true);
        this.dom.termsSection.setAttribute('aria-expanded', true);
    }

    CloseText() {
        this.setAttribute('expanded', false);
        this.dom.termsSection.setAttribute('aria-expanded', false);
    }

    Open(event) {
        document.body.classList.add('gtc:scroll-lock');
        this.setAttribute('open', '');
        this.AddListeners();

        if (event.detail.expandOnLoad === true) {
            this.ExpandText(event);
        }
    }

    Close() {
        document.body.classList.remove('gtc:scroll-lock');
        this.removeAttribute('open', '');
        this.RemoveListeners();
        this.CloseText()
    }

    Keydown(event) {
        // If Esc key
        if (event.keyCode !== 27) return;
        this.Close();
    }


    ExpandText(event) {
        event.preventDefault();
        if (this.settings.expandedTextLoaded) {
            this.OpenText();
        } else {
            this.FetchFullTermsText();
        }
    }


    async FetchFullTermsText() {
        const pageContent = await getPageContentHtml(this.settings.url);

        this.dom.expandedContent.insertAdjacentHTML('afterbegin', pageContent);
        this.settings.expandedTextLoaded = true;
        this.OpenText();
    }
}
customElements.define('gtc-terms-modal', GTCTermsModal)